module.exports = __webpack_public_path__ + "img/xp-tb-slots.b46a1b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-slots.png
// module id = ZTXC
// module chunks = 38 43